/* Product families: the catalogue is grouped into one card per family.
   Each family maps to existing products via category (+ optional insulation split).
   To add a future range (e.g. 33 kV HT cables), add an entry here with
   products seeded under its `category` — everything else picks it up automatically. */

export const FAMILIES = [
    {
        slug: "house-building-wires",
        name: "House & Building Wires",
        tag: "FR · FRLS · HRFR PVC",
        category: "Building Wires",
        voltage: "650/1100 V",
        brands: ["KEI", "Polycab", "Havells"],
        standard: "IS 694",
        conductor: "Copper",
        insulation: "FR / FRLS PVC",
        armour: "None / Unarmoured",
        datasheet: "",
    },
    {
        slug: "lt-power-cables",
        name: "LT Power Cable 1.1 kV",
        tag: "XLPE · 1.1 kV",
        category: "LT Power Cables",
        voltage: "1.1 kV",
        brands: ["KEI", "Polycab", "Havells"],
        standard: "IS 7098 Part 1",
        conductor: "Copper / Aluminium",
        insulation: "XLPE",
        armour: "SWA (select variants)",
        datasheet: "",
    },
    {
        slug: "control-cables",
        name: "Control Cables 1.1 kV",
        tag: "2–61 Cores",
        category: "Control Cables",
        voltage: "1.1 kV",
        brands: ["KEI", "Polycab", "Havells"],
        standard: "IS 1554 Part 1",
        conductor: "Copper",
        insulation: "PVC",
        armour: "Unarmoured / SWA",
        datasheet: "",
    },
    {
        slug: "instrumentation-cables",
        name: "Instrumentation Cables",
        tag: "Screened Pairs",
        category: "Instrumentation",
        voltage: "300/500 V",
        brands: ["KEI", "Polycab", "Havells"],
        standard: "Confirm at quotation",
        conductor: "Copper",
        insulation: "PE / PVC",
        armour: "Overall screen",
        datasheet: "",
    },
    {
        slug: "flexible-welding-cables",
        name: "Flexible & Welding Cables",
        tag: "Class 5 Fine-Strand",
        category: "Flexible & Welding",
        voltage: "600/1000 V",
        brands: ["KEI", "Polycab", "Havells"],
        standard: "IS 694 / IS 9857",
        conductor: "Copper",
        insulation: "PVC / Rubber / EPR",
        armour: "None / Unarmoured",
        datasheet: "",
    },
    {
        slug: "solar-pv-cables",
        name: "Solar PV DC Cable",
        tag: "1.5 kV DC · EN 50618",
        category: "Solar PV",
        voltage: "1.5 kV DC",
        brands: ["KEI", "Polycab", "Havells"],
        standard: "EN 50618",
        conductor: "Tinned Copper",
        insulation: "XLPO",
        armour: "None / Unarmoured",
        datasheet: "",
    },
    {
        slug: "submersible-cables",
        name: "Submersible Pump Cables",
        tag: "Flat & Round",
        category: "Submersible",
        voltage: "1.1 kV",
        brands: ["KEI", "Polycab", "Havells"],
        standard: "Confirm at quotation",
        conductor: "Copper",
        insulation: "PVC",
        armour: "None / Unarmoured",
        datasheet: "",
    },
    {
        slug: "aluminium-armoured-power",
        name: "Aluminium Armoured Power Cable 1.1 kV",
        tag: "Al · XLPE · SWA",
        category: "Armoured",
        voltage: "1.1 kV",
        brands: ["KEI", "Polycab", "Havells"],
        standard: "IS 7098 Part 1",
        conductor: "Aluminium",
        insulation: "XLPE",
        armour: "SWA",
        datasheet: "",
    },
    {
        slug: "copper-armoured-control",
        name: "Copper Armoured Control Cable 1.1 kV",
        tag: "Cu · PVC · SWA · 2–24 Cores",
        category: "Copper Armoured",
        insulationMatch: "PVC",
        voltage: "1.1 kV",
        brands: ["KEI", "Polycab", "Havells"],
        standard: "IS 1554 Part 1",
        conductor: "Copper",
        insulation: "PVC",
        armour: "SWA",
        datasheet: "",
    },
    {
        slug: "copper-armoured-power",
        name: "Copper Armoured Power Cable 1.1 kV",
        tag: "Cu · XLPE · SWA",
        category: "Copper Armoured",
        insulationMatch: "XLPE",
        voltage: "1.1 kV",
        brands: ["KEI", "Polycab", "Havells"],
        standard: "IS 7098 Part 1",
        conductor: "Copper",
        insulation: "XLPE",
        armour: "SWA",
        datasheet: "",
    },
    {
        slug: "ht-11kv-ug-cables",
        name: "11 kV HT UG Cable",
        tag: "11 kV · XLPE · Underground",
        category: "HT Cables",
        voltage: "11 kV",
        brands: ["KEI", "Polycab", "RPG"],
        standard: "IS 7098 Part 2",
        conductor: "Aluminium / Copper",
        insulation: "XLPE",
        armour: "Flat Strip / Round Wire",
        datasheet: "",
    },
    /* Future range placeholder — uncomment when 33 kV HT cables are stocked:
    {
        slug: "ht-33kv-ug-cables",
        name: "33 kV HT UG Cable",
        tag: "33 kV · XLPE · Underground",
        category: "HT Cables 33 kV",
        voltage: "33 kV",
        brands: ["KEI", "Polycab", "RPG"],
        standard: "IS 7098 Part 2",
        conductor: "Aluminium / Copper",
        insulation: "XLPE",
        armour: "Flat Strip / Round Wire",
        datasheet: "",
    }, */
    {
        slug: "glands-lugs",
        name: "Cable Glands & Lugs",
        tag: "Brass & Copper",
        category: "Glands & Lugs",
        voltage: "Accessory",
        brands: ["Dowells"],
        standard: "Dowells catalogue spec",
        conductor: "Brass / Copper",
        insulation: "—",
        armour: "—",
        datasheet: "",
    },
    {
        slug: "jointing-termination-kits",
        name: "Cable Jointing & Termination Kits",
        tag: "HT & LT · up to 33 kV terminations",
        category: "Cable Jointing Kits",
        voltage: "Up to 33 kV (terminations)",
        brands: ["Raychem", "3M"],
        standard: "Raychem / 3M kit spec",
        conductor: "—",
        insulation: "Heat-shrink",
        armour: "—",
        datasheet: "",
    },
];

export const familySlug = (s) => s; // slugs are pre-computed above

export const familyOf = (p) =>
    FAMILIES.find(
        (f) => f.category === p.category && (!f.insulationMatch || f.insulationMatch === p.insulation)
    ) || null;

export const familyBySlug = (slug) => FAMILIES.find((f) => f.slug === slug) || null;

export const familyMembers = (products, fam) =>
    products.filter((p) => familyOf(p)?.slug === fam.slug);

/* Backwards-compat: old /category/<slug> URLs map onto the matching family */
export const LEGACY_CATEGORY_MAP = {
    "building-wires": "house-building-wires",
    "lt-power-cables": "lt-power-cables",
    "control-cables": "control-cables",
    instrumentation: "instrumentation-cables",
    "flexible-welding": "flexible-welding-cables",
    "solar-pv": "solar-pv-cables",
    submersible: "submersible-cables",
    armoured: "aluminium-armoured-power",
    "copper-armoured": "copper-armoured-control",
    "ht-cables": "ht-11kv-ug-cables",
    "glands-lugs": "glands-lugs",
    "cable-jointing-kits": "jointing-termination-kits",
};
